// extracted by mini-css-extract-plugin
module.exports = {"card":"hair-card_card__dwNNV","name-age":"hair-card_name-age__qzVf0","state":"hair-card_state__qnQq8"};